import { Renderer } from '@unseenco/taxi'
import { viewStorage } from '../_globals'
import NewsletterHubspot from '../modules/newsletter-hubspot'

export default class PageNewsletter extends Renderer {
  initialLoad() {
    document.addEventListener('DOMContentLoaded', () => {
      window.addEventListener('load', () => this.onEnter())
    })
  }

  onEnter() {
    this.DOM = {
      close: viewStorage.current.querySelector('.Close')
    }

    if (this.DOM.close) this.DOM.close.remove() 

    this.newsletterHubspotModule = new NewsletterHubspot(viewStorage.current)
  }

  onLeaveCompleted() {
    this.newsletterHubspotModule && this.newsletterHubspotModule.destroy()
  }
}
